/**
 * System Lizard - Audio Recorder Utility
 * Records master output from Web Audio API and exports downloadable audio samples.
 */

export class AudioRecorder {
  constructor(synthEngine) {
    this.synth = synthEngine;
    this.mediaRecorder = null;
    this.audioChunks = [];
    this.isRecording = false;
  }

  startRecording() {
    if (!this.synth.ctx || !this.synth.masterGain) return false;
    
    // Create MediaStreamDestination node
    const streamDest = this.synth.ctx.createMediaStreamDestination();
    this.synth.masterGain.connect(streamDest);

    this.audioChunks = [];
    const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
      ? 'audio/webm;codecs=opus'
      : 'audio/webm';

    this.mediaRecorder = new MediaRecorder(streamDest.stream, { mimeType });

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.audioChunks.push(event.data);
      }
    };

    this.mediaRecorder.start();
    this.isRecording = true;
    return true;
  }

  stopRecording() {
    return new Promise((resolve) => {
      if (!this.mediaRecorder || !this.isRecording) {
        resolve(null);
        return;
      }

      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.audioChunks, { type: 'audio/webm' });
        const url = URL.createObjectURL(blob);
        this.isRecording = false;
        resolve({ blob, url });
      };

      this.mediaRecorder.stop();
    });
  }
}
